/* eslint-disable max-classes-per-file */
import { DateDrillDownSelectorComponent } from "./../date-drill-down-selector.component";
import { DateDrillDownSelectedItem } from "./dateDrillDownSelectedItem";
import { PeriodType } from "./periodType";

export class DateDrillDownItem {

    parent: DateDrillDownSelectorComponent;
    label: string;
    expanded: boolean;
    startDate: Date;
    endDate: Date;
    outsidePeriod: boolean;
    disabled: boolean;
    active: boolean;
    startDateActive: any;

    constructor(parent: DateDrillDownSelectorComponent) {
        this.parent = parent;
        this.expanded = false;
    }

    toggleExpanded() {
        this.expanded = !this.expanded;
    }

    selected() {
        if (!this.disabled) {

            let periodType = "";
            const dateItem = this as any;
            let periodMonth;
            if (dateItem instanceof DateDrillDownPeriod) {
                periodType = PeriodType.period;
            } else if (dateItem instanceof DateDrillDownMonth) {
                periodType = PeriodType.month;
            } else if (dateItem instanceof DateDrillDownWeek) {
                periodType = PeriodType.week;
            } else if (dateItem instanceof DateDrillDownDay) {
                periodType = PeriodType.day;
            }

            if (periodType === PeriodType.week) {
                const month = this.startDateActive;
                periodMonth = new Date(month.getFullYear(), month.getMonth(), 1);
            }

            const selectedItem = new DateDrillDownSelectedItem(this.label, periodType, periodMonth, this.startDate, this.endDate);

            this.parent.onDateSelected({ item: selectedItem });
            this.parent.inactivateAll();
            this.active = !this.active;
        }
    }

    updateDate() {
        this.parent.onEditPeriod();
    }
}

export class DateDrillDownDay extends DateDrillDownItem {

}

export class DateDrillDownMonth extends DateDrillDownItem {

    weeks: DateDrillDownWeek[];

    toggleExpanded() {

        if (!this.weeks) {
            this.weeks = this.parent.setupWeeks(this);
        }

        super.toggleExpanded();
    }
}

export class DateDrillDownPeriod extends DateDrillDownItem {

}

export class DateDrillDownWeek extends DateDrillDownItem {
    days: DateDrillDownDay[];
    startDateActive: Date;
    endDateActive: Date;

    toggleExpanded() {

        if (!this.days) {
            this.days = this.parent.setupDays(this);
        }

        super.toggleExpanded();
    }
}

export interface IDateDrillDownBindings {
    startDate: Date;
    endDate: Date;
    dateDepth: string;
    enableEditPeriod: boolean;

    onDateSelected: (param: any) => any;
    onEditPeriod: () => any;
    onClose: () => any;
}
